// hooks/useUploadImages.js
import { useMutation } from '@tanstack/react-query';

const API_URL =
  import.meta.env.VITE_PAWFRIENDS_UPLOAD_IMAGES_API_ENDPOINT || '';

async function uploadImages({files, folder}) {
  if (!Array.isArray(files)) {
    throw new Error('Files must be an array');
  }

  const formData = new FormData();
  formData.append('folder', folder);
  files.forEach(file => formData.append('images', file));

  try {
    const res = await fetch(API_URL, {
      method: 'POST',
      body: formData,
    });
    if (!res.ok) {
      console.log('error', res.text());
      throw new Error('Failed to upload images');
    }

    console.log("Images uploaded");

    return res.json(); // { urls: [...] }
  } catch (err) {
    console.log('Failed to upload images', err);
    throw new Error('Upload failed');
  }
}

export default function useUploadImages() {
  return useMutation({
    mutationFn: uploadImages
  });
}
